<mat-form-field #formFieldContainer floatLabel="always" appearance="none" class="ft-checklist-comment-main-wrap  f-flex f-flex-column">
  <mat-label
    #labelContainer  (click)="toggleTooltip(tooltip)"
    class="{{componentDefinition?.mandatory ? 'mandatory' : ''}} ">
    {{componentDefinition?.label}}
  </mat-label>
  <div class="labelToolTipContainer"
       #tooltip="matTooltip"
       matTooltip="{{componentDefinition.label}}"
       [matTooltipDisabled]="showToolTip(tooltip,formFieldContainer,labelContainer)">
  </div>
  <input matInput [hidden]="true"
         [id]="componentDefinition?.name" [name]="componentDefinition?.name"
  />

  <div class="checklist-comment-wrap f-flex">
    <div *ngFor='let quesOption of checkList.items.controls; let i = index;' class="checklist-comment-child f-flex f-flex-justify-space-between">
          <mat-checkbox  color="primary"  class="sc-checklist-margin"
                        [name]="componentDefinition?.name + i" [id]="componentDefinition?.name + i"
                        [formControl]="quesOption"
                        (change)="onChange(i)">{{componentDefinition?.list[i]}}
          </mat-checkbox>
          <mat-form-field>
              <input matInput [formControl]="checkListCommentControlTextField.items.controls[i]"
                      [name]="componentDefinition?.name +'_ListComment'+ i"
                      [id]="componentDefinition?.name +'ListComment'+ i" >
          </mat-form-field>
    </div>
  </div>

</mat-form-field>
<ft-validation-display [model]="document" [componentDefinition]="componentDefinition"></ft-validation-display>
